import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

/**
 * Returns the read-only hint for an item's Name field. The field edits the invoice name,
 * and the hint shows the source name the item was added with.
 */
export const getSourceNameTooltip = (sourceName: string | Nullish) =>
  isNilOrEmpty(sourceName) ? undefined : i18n.t('general.labels.sourceName', {name: sourceName});
